import { render } from "./TelaCarregamento.vue?vue&type=template&id=526d4671&scoped=true"
import script from "./TelaCarregamento.vue?vue&type=script&lang=js"
export * from "./TelaCarregamento.vue?vue&type=script&lang=js"

import "./TelaCarregamento.vue?vue&type=style&index=0&id=526d4671&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3986129723/src/app-csd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526d4671"]])

export default __exports__